import {createReducer} from '@reduxjs/toolkit'
import {
    dRefundsClearFiltersAC,
    dRefundSetDetailItemFromSalesAC,
    dRefundsSetDataAC,
    dRefundsSetDetailItemAC,
    dRefundsSetFiltersAC,
    dRefundsSetItemsForPageAC,
    dRefundsSetPageNumberAC,
    dRefundsSetPaginationAC
} from 'model/dashboardRefunds/dRefundsActionCreators';

import {typePagination} from '../system/constants';
import {logoutAC, resetReducers} from 'model/system/systemActionCreators';
import {IdStoresStateDataItem} from "../dashboardStores/dStoresReducer";



// Type
export type IdRefundsStateDataItem = {

    id: string,
    date: string,
    amount: string,
    appletVersion: string,
    cashierId: string,
    store: IdStoresStateDataItem,
    fiscalSign:	string,
    fmId:	string,
    receiptNumber:	string,
    userId: string,
    userName: string,
    zreportNumber:	string
    productsCount: string
}

export type typeRefundsFilters = {

    date?: {
        from: string | null,
        to: string | null,
    } | null,
    userName?: string | null,

    fmId?: string | null
    storeId?: string | null,

}
export type IdRefundsState = {
    pagination: typePagination,
    data: IdRefundsStateDataItem[],
    detailItem: IdRefundsStateDataItem | undefined,
    filters: typeRefundsFilters
}


// Init state
export const initialState: IdRefundsState = {
    pagination: {
        pageNumber: 0,
        itemsPerPage: 14,
    },
    data: [],
    detailItem: undefined,
    filters: {

        date: null,
        fmId:null,
        userName: null,
        storeId: null,


    }
}


// Reducer
export const DRefundsReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dRefundsSetDataAC, (state, action) => {
            state.data = action.payload.dataList
        })

        // Reducer of set pagination
        .addCase(dRefundsSetPaginationAC, (state, action) => {
            state.pagination = {...state.pagination, ...action.payload.pagination}
        })
        // Reducer of set items for page pagination
        .addCase(dRefundsSetItemsForPageAC, (state, action) => {
            state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
        })
        // Reducer of set pageNumber pagination
        .addCase(dRefundsSetPageNumberAC, (state, action) => {
            state.pagination.pageNumber = action.payload.pageNumber
        })

        // Reducer of set detail item
        .addCase(dRefundsSetDetailItemAC, (state, action) => {
            state.detailItem = state.data.find((item) => item.id === action.payload)
        })
        // Reducer of set detail item
        .addCase(dRefundSetDetailItemFromSalesAC, (state, action) => {
            state.detailItem = action.payload
        })

        // Reducer of clear filtersForm
        .addCase(dRefundsClearFiltersAC, (state) => {
            state.filters.date = null
            state.filters.userName= null
            state.filters.fmId = null
            state.filters.storeId = null
        })

        // Reducer of set filtersForm
        .addCase(dRefundsSetFiltersAC, (state, action) => {
            state.filters = {...state.filters, ...action.payload}
            state.pagination.pageNumber = 0

        })
        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailItem=initialState.detailItem
            state.filters = initialState.filters
            state.pagination = initialState.pagination
        })

        .addCase(resetReducers, (state, action) => {
            if (action.payload !== "refunds") {
                state.data = initialState.data
                state.detailItem=initialState.detailItem
                state.filters = initialState.filters
                state.pagination = initialState.pagination
            }
        });
})
